<template>
	<div class="nav">
		<div class="logo">
			<img src="@/assets/logo.png" alt="">
		</div>
		<div class="navbody" v-if='htmlon'>
			<el-menu :default-active='nowIndex' class="el-menu-vertical-demo" active-text-color="#ffd04b">
				<el-submenu :index="index+''" v-for='(item,index) in routes' :key='index' v-if='!item.hidden' >
					<template slot="title" >
						<div class="menus">
							<svg-icon  :icon-class='item.meta.icon' v-if='item.meta.icon' class='icon' />
							<p>{{item.meta.title}}</p>
						</div>
					</template>
					<el-menu-item-group >
						<el-menu-item  @click='pageTo(child.path)' v-if='!child.meta.hidden' :index="index+'-'+i" v-for='(child,i) in item.children' :key='i'>
							<div class="menus">
								<p>{{child.meta.title}}</p>
							</div>
						</el-menu-item>
					</el-menu-item-group>
				</el-submenu>
			</el-menu>

		</div>
		<div class="navbody" v-else>
			<div @click='pageonChange(index)' class="li" :class='on==index?"on":""' v-for='(item,index) in pages' :key='index' >
				<svg-icon :icon-class='item.icon' class='icon' />
				<p>{{item.title}}</p>
			</div>
		</div>


		<div class="keyBtnbody" v-if='!htmlon'>
			<el-popover placement="right" title="键盘快捷键" width="200" trigger="hover">
				<div class="keyboard">
					<div class="li"> <span>CTRL + S</span> 保存</div>
					<div class="li"> <span>CTRL + Z</span> 撤销</div>
					<div class="li"> <span>CTRL + Y</span> 恢复</div>
					<div class="li"> <span>DELETE</span> 删除模块(自由容器)</div>
					<div class="li"> <span>↑ ↓ ← →</span> 模块平移</div>
					<div class="li"> <span>CTRL + `</span> 控制台</div>
				</div>
				<svg-icon icon-class='question' class='keyBtnLeft' slot="reference"/>
			</el-popover>
		</div>
	</div>
</template>
<script>
	export default{
		data(){
			return {
				pages:this.$store.state.pages,
				route: this.$router.options.routes,
				on:this.$store.state.pageon,
				nowIndex:"0"
			}
		},
		props:{
			htmlon:Number
		},
		watch:{
			'$store.state.pageon':{
				handler(val){
					this.on = val
				}
			}
		},
		methods:{
			pageonChange(index){
				this.on = index;
				this.$store.commit('pageonChange',index)
			},
			pageTo(url){
				console.log(url)
				this.$router.push({
					path:url
				})
			},
		},
		computed:{
			routes() {
				return this.$router.options.routes
			},
		},
		mounted(){
		},
	}
</script>
<style scoped>
.nav{
}
.navbody{

}
.menus{
	display: flex;
	align-items: center;
}
.menus .icon{
	margin: 0 10px;
	color: #bfbfbf;
}
.navbody .on{
	background: #111619 !important;
	color: #fff !important;
}
.navbody .li{
	cursor: pointer;
	color: #666;
	height: 90px;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	padding: 10px;
	font-size: 14px;
}
.navbody .li .icon{
	width: 24px;
	height: 24px;
	margin-bottom: 10px;
}
.navbody .li:hover{
	background: #1f2529;
}
.keyBtnbody{
	width: 70px;
	height: 70px;
	left:0;
	bottom: 0;
	position: absolute;
	display: flex;
	align-items: center;
	justify-content: center;
}
.keyBtnbody .keyBtnLeft{
	color: #fff;
	width: 26px;
	height: 26px;
}
.keyboard{
	color: #666;
}
.keyboard .li{
	margin-bottom: 6px;
}
.keyboard span{
	width: 80px;
	font-size: 12px;
	color: #aaa;
	display: inline-flex;

}
</style>


// WEBPACK FOOTER //
// src/views/laout/components/leftNav.vue